import React, { useContext, useEffect, useState } from "react";
import HeadBar from "./headBar/HeadBar";
import Footer from "./footer/Footer";
import Breadcrumb from "./breacrumb/breadcrumb";
import PageHeader from "../pageheader/PageHeader";
import * as notifyApi from "../../service/notifyApi";
import * as patientApi from "../../service/patientApiDev";
import { RedirectCode400 } from "../RedirectCode400";
import { CurrentUserContext } from "../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faCheck,
  faClose,
  faFileLines,
  faQuestion,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

function Notification({ role }) {
  const { userRole, setUserRole, setIsMessage } =
    useContext(CurrentUserContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [notifyList, setNotifyList] = useState([]);
  const [new_notify, setNew_nottify] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [selectstatus, setSelectstatus] = useState("ALL");
  const [permission_list, setPermission_list] = useState([]);
  const [permission_list_storage, setPermission_list_storage] = useState([]);
  const [getNotificationTotal, setGetNotificationTotal] = useState(
    localStorage.getItem("Notification"),
  );
  const [checkUserAfterLogin, setCheckUserAfterLogin] = useState(
    localStorage.getItem("user"),
  );
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (user["auth"]["ial"] === 1) {
      navigate("/manageinfo");
      setIsMessage({
        type: "warning",
        data: "ระดับการพิสูจน์ตัวตนต่ำเกิน กรุณาเพิ่มระดับการพิสูจน์ตัวตน",
      });
    } else if (user["auth"]["ial"]["level"] === 1) {
      navigate("/manageinfo");
      setIsMessage({
        type: "warning",
        data: "ระดับการพิสูจน์ตัวตนต่ำเกิน กรุณาเพิ่มระดับการพิสูจน์ตัวตน",
      });
    } else if (user["auth"]["ial"]["level"] === "1") {
      navigate("/manageinfo");
      setIsMessage({
        type: "warning",
        data: "ระดับการพิสูจน์ตัวตนต่ำเกิน กรุณาเพิ่มระดับการพิสูจน์ตัวตน",
      });
    } else {
      if (localStorage.getItem("Notification") === null) {
        setGetNotificationTotal(0);
      } else {
        // console.log(getNotificationTotal)
      }
      getRequestNotification();
      setUserRole(user);
      // console.log(user)
      if (user?.["auth"]["role"][0] === "PATIENT") {
        getRequestPermission();
      }
    }
  }, [checkUserAfterLogin]);

  const pathItems = [
    { name: "หน้าหลัก", url: `${role ?? ""}/` },
    { name: "แจ้งเตือน", url: `${role ?? ""}/notification` },
  ];

  const getRequestNotification = async () => {
    setLoading(true);
    let res = await notifyApi.getNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setNotifyList(res["data"]["notification_list"]);
        localStorage.setItem(
          "Notification",
          res["data"]["notification_list"].length,
        );
        setNew_nottify(res["data"]["is_new_badge"]);
      } else if (res["data"]["code"] === 401) {
        setIsMessage({ type: "error", data: "หมดเวลาใช้งาน" });
        localStorage.clear();
        navigate("/login");
        return;
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await patientApi.getRequestPermission(selectstatus, page, 10);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setPermission_list(res["data"]["permission_list"]);
        setPermission_list_storage(res["data"]["permission_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const permissionFillter = (permission_id) => {
    let permission_list = permission_list_storage.filter((elements) => {
      return elements["permission_id"].includes(permission_id);
    });

    if (permission_list.length === 0) {
      return "";
    }
    return permission_list[0]["status"];
  };

  const goToDetail = () => {
    navigate("/patient/permissionAccessData", {
      state: { type: "accessHistory" },
    });
  };

  return (
    <>
      <div className="global-page">
        <h1 className="sr-only">แจ้งเตือน</h1>
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename={"แจ้งเตือน"} />
        {notifyList.length > 0 ? (
          <div className="flex flex-col w-full">
            {notifyList.map((i, idx) => (
              <div key={idx + 1}>
                {String(user["auth"]["role"]) === "PATIENT" ? (
                  <div>
                    {permissionFillter(
                      i["payload"]["data"]["permission_id"],
                    ) === "PENDING" ? (
                      <div
                        key={idx}
                        className="lg:gap-4 flex flex-row items-center gap-8 w-full py-4 border-b border-gray-400 bg-white cursor-pointer transition-transform duration-200 hover:scale-[101%]"
                        onClick={() => goToDetail()}
                      >
                        <FontAwesomeIcon
                          icon={faUser}
                          className="p-2 text-sm text-amber-900 bg-[#f8eee2] rounded-md"
                        />
                        <div className="2lg:text-sm lg:min-w-[78px] w-[15%] text-lg text-wrap">
                          {i["create_date"]["date"]} {i["create_date"]["time"]}
                        </div>
                        <div className="2md:text-base flex flex-col gap-2 w-full text-lg">
                          <span className="2md:text-sm text-base text-gray-600">
                            {i["payload"]["topic"]}
                          </span>
                          <span>{i["payload"]["detail"]} กรุณากดอนุมัติ</span>
                        </div>
                      </div>
                    ) : permissionFillter(
                        i["payload"]["data"]["permission_id"],
                      ) === "ACCEPT" ? (
                      <div
                        key={idx}
                        className="lg:gap-4 flex flex-row items-center gap-8 w-full py-4 border-b border-gray-400 bg-white cursor-pointer transition-transform duration-200 hover:scale-[101%]"
                        onClick={() => goToDetail()}
                      >
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="p-2 text-sm text-light-green-500 bg-[#e7fcdf] rounded-md"
                        />
                        <div className="2lg:text-sm lg:min-w-[78px] w-[15%] text-lg text-wrap">
                          {i["create_date"]["date"]} {i["create_date"]["time"]}
                        </div>
                        <div className="2md:text-base flex flex-col gap-2 w-full text-lg">
                          <span className="2md:text-sm text-base text-gray-600">
                            {i["payload"]["topic"]}
                          </span>
                          <span>คำขอเข้าถึงข้อมูลได้รับอนุญาตแล้ว</span>
                        </div>
                      </div>
                    ) : permissionFillter(
                        i["payload"]["data"]["permission_id"],
                      ) === "REJECT" ? (
                      <div
                        key={idx}
                        className="lg:gap-4 flex flex-row items-center gap-8 w-full py-4 border-b border-gray-400 bg-white cursor-pointer transition-transform duration-200 hover:scale-[101%]"
                        onClick={() => goToDetail()}
                      >
                        <FontAwesomeIcon
                          icon={faClose}
                          className="p-2 text-sm text-red-400 bg-[#fcdfdf] rounded-md"
                        />
                        <div className="2lg:text-sm lg:min-w-[78px] w-[15%] text-lg text-wrap">
                          {i["create_date"]["date"]} {i["create_date"]["time"]}
                        </div>
                        <div className="2md:text-base flex flex-col gap-2 w-full text-lg">
                          <span className="2md:text-sm text-base text-gray-600">
                            {i["payload"]["topic"]}
                          </span>
                          <span>คำขอเข้าถึงข้อมูลถูกปฏิเสธ</span>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : String(user["auth"]["role"]) === "MEDICAL_PERSONNEL" ? (
                  <div
                    key={idx}
                    className="lg:gap-4 flex flex-row items-center gap-8 w-full py-4 border-b border-gray-400 bg-white cursor-pointer transition-transform duration-200 hover:scale-[101%]"
                    onClick={() => navigate("/search-for-patient-information")}
                  >
                    <FontAwesomeIcon
                      icon={faBell}
                      className="p-2 text-sm text-amber-900 bg-[#f8eee2] rounded-md"
                    />
                    <div className="2lg:text-sm lg:min-w-[78px] w-[15%] text-lg text-wrap">
                      {i["create_date"]["date"]} {i["create_date"]["time"]}
                    </div>
                    <div className="2md:text-base flex flex-col gap-2 w-full text-lg">
                      <span className="2md:text-sm text-base text-gray-600">
                        {i["payload"]["topic"]}
                      </span>
                      <span>{i["payload"]["detail"]}</span>
                    </div>
                  </div>
                ) : (
                  <div
                    key={idx}
                    className="lg:gap-4 flex flex-row items-center gap-8 w-full py-4 border-b border-gray-400 bg-white cursor-pointer transition-transform duration-200 hover:scale-[101%]"
                    onClick={() => navigate("/search-for-patient-information")}
                  >
                    <FontAwesomeIcon
                      icon={faBell}
                      className="p-2 text-sm text-amber-900 bg-[#f8eee2] rounded-md"
                    />
                    <div className="2lg:text-sm lg:min-w-[78px] w-[15%] text-lg text-wrap">
                      {i["create_date"]["date"]} {i["create_date"]["time"]}
                    </div>
                    <div className="2md:text-base flex flex-col gap-2 w-full text-lg">
                      <span className="2md:text-sm text-base text-gray-600">
                        {i["payload"]["topic"]}
                      </span>
                      <span>{i["payload"]["detail"]}</span>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="w-full text-lg text-gray-600 m-[5%] rounded-md">
            ไม่มีข้อมูลการแจ้งเตือน
          </div>
        )}
      </div>
    </>
  );
}

export default Notification;
